import { render, staticRenderFns } from "./AcceptedRecommendationSummary.vue?vue&type=template&id=1837ca38"
import script from "./AcceptedRecommendationSummary.vue?vue&type=script&lang=js"
export * from "./AcceptedRecommendationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports